<template functional>
  <ul
    v-bind="data.attrs"
    class="footer-social"
  >

    <li class="footer-social__item">
      <a
        aria-label="YouTube"
        href="https://www.youtube.com/user/CSStiftung"
        rel="noopener"
        target="_blank"
      >
        <img
          alt=""
          class="footer-social__image"
          height="25"
          src="@/assets/youtube.svg"
        >
      </a>
    </li>

    <li class="footer-social__item">
      <a
        aria-label="LinkedIn"
        href="https://de.linkedin.com/company/claussen-simon-stiftung"
        rel="noopener"
        target="_blank"
      >
        <img
          alt=""
          class="footer-social__image"
          height="25"
          src="@/assets/linkedin.svg"
        >
      </a>
    </li>

    <li class="footer-social__item">
      <a
        aria-label="Instagram"
        href="https://www.instagram.com/claussen.simon.stiftung/"
        rel="noopener"
        target="_blank"
      >
        <img
          alt=""
          class="footer-social__image"
          height="25"
          src="@/assets/instagram.svg"
        >
      </a>
    </li>

  </ul>
</template>

<script>
export default {
  name: 'AFooterSocial'
}
</script>

<style scoped>
.footer-social {
  list-style: none;

  display: flex;
  margin: 0;
  padding: 0;
}

.footer-social__item {
  margin-right: calc(var(--grid-spacing) / 3);
}

.footer-social__image {
  width: auto;
  height: 25px;
  vertical-align: middle;
}
</style>
